/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'fierry/data/entity';
import Collection from 'fierry/data/collection';

import Zone from 'solis/data/colony/zone';


export default class Sector extends Entity
{
  static children = [ 'zones' ];


  loadZone (cass)
  {
    return this.getZones().load(cass.id, cass);
  }


  unloadZone (cass)
  {
    this.getZones().unload(cass.id);
  }


  createZone (id)
  {
    const cass = {};

    cass.galaxy = this.cass.galaxy;
    cass.colony = this.cass.colony;
    cass.sector = this.cass.id;

    cass.id = id;

    cass.value = 1;
    cass.rule = null;

    return this.parent.loadZone(cass);
  }


  getColony ()
  {
    return this.parent;
  }


  getZone (relativeHex)
  {
    return this.getZones().at(relativeHex);
  }


  getZones ()
  {
    return new Collection(Zone, this.cursor.child('zones'), this.parent);
  }


};
